export default {"src":"/_next/static/media/flag-de.1fe47647.svg","height":3,"width":5,"blurWidth":0,"blurHeight":0};